import { Component, OnInit } from '@angular/core';
import { faDna, faHeartbeat } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-emuseplatform',
  templateUrl: './emuseplatform.component.html',
  styleUrls: ['./emuseplatform.component.css']
})
export class EmuseplatformComponent implements OnInit {

  constructor() { }
  faDna = faDna;
  faHeartbeat = faHeartbeat;

  ngOnInit(): void {
  }

}
